import { render, staticRenderFns } from "./EditableGridDemo.vue?vue&type=template&id=96a0d81e&"
import script from "./EditableGridDemo.vue?vue&type=script&lang=js&"
export * from "./EditableGridDemo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports